module.exports = __webpack_public_path__ + "assets/img/globe-01.df23bb3a.svg";